import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface Prize {
  id: string;
  event_id: string;
  category: string;
  description: string;
  amount?: number;
  created_at: string;
}

export function usePrizes(eventId: string) {
  const [prizes, setPrizes] = useState<Prize[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPrizes = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('prizes')
        .select('*')
        .eq('event_id', eventId)
        .order('category', { ascending: true });

      if (error) throw error;
      
      setPrizes(data || []);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (eventId) {
      fetchPrizes();
    }
  }, [eventId]);

  const refetch = () => {
    fetchPrizes();
  };

  return { prizes, loading, error, refetch };
}